import axios from "axios";
import FileSaver from "file-saver";

import { PublicationI } from "@PublicationReader/@types/Publication";

export const downloadPdf = async (
  apiDownloadUrl: string,
  publication: PublicationI,
  sectionsQuery?: string
): Promise<string> => {
  const { id, isPreviewMode } = publication;
  let endpoint = `${apiDownloadUrl}/${id}?preview=${isPreviewMode}`;

  if (sectionsQuery) {
    endpoint += sectionsQuery;
  }

  const res = await axios.get(endpoint, {
    responseType: "blob",
  });

  return new Promise(function (resolve) {
    const blob = new Blob([res.data], { type: "application/pdf" });
    FileSaver.saveAs(blob, publication.pdfFileName);
    resolve("File saved");
  });
};
